/**
 * REST client for the conference history surface.
 * Mirrors `backend/src/conferenceLive/historyService.ts` (and the
 * routes wired in `historyRouter.ts`).
 */
import { apiFetch } from './client';

export interface SessionSummary {
  id: string;
  room_id: string;
  started_at: string;
  ended_at: string | null;
  duration_seconds: number | null;
  participant_count: number;
  unique_caller_count: number;
  had_moderator: boolean;
  ended_reason: string | null;
  recording_customer_path: string | null;
  had_backend_recording: boolean;
}

export interface ParticipantHistory {
  id: string;
  caller_id_number: string | null;
  is_host: boolean;
  joined_at: string;
  left_at: string | null;
  raised_hand_count: number;
}

export interface EventEntry {
  id: string;
  occurred_at: string;
  kind: string;
  member_id: string | null;
  display_name: string | null;
  e164: string | null;
  details: Record<string, unknown> | null;
}

export interface SessionDetail extends SessionSummary {
  participants: ParticipantHistory[];
  events: EventEntry[];
}

export interface ListSessionsOpts {
  /**
   * When true (default), the API filters out sessions where no
   * moderator joined. Set to false to include every session.
   */
  hasModerator?: boolean;
  limit?: number;
  offset?: number;
}

function qs(params: Record<string, string | number | boolean | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null) sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

export const conferenceHistory = {
  list: (roomId: string, opts: ListSessionsOpts = {}) =>
    apiFetch<{ rows: SessionSummary[]; total: number }>(
      `/api/conferences/${encodeURIComponent(roomId)}/history${qs({
        has_moderator: opts.hasModerator ?? true,
        limit: opts.limit,
        offset: opts.offset,
      })}`,
    ),

  detail: (sessionId: string) =>
    apiFetch<SessionDetail>(
      `/api/conferences/sessions/${encodeURIComponent(sessionId)}/history`,
    ),
};
